import { fetchPresenters } from '../../../models/presenters'

const getPresenters = async context => {
  try {
    const response = await fetchPresenters()
    context.commit('PRESENTERS_UPDATED', response)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

export default {
  getPresenters,
}
